/**
 * Sysadmin Functions catalog — pure layout route (R5 P0-2 fix, 2026-05-13).
 *
 * Before the fix, this file held both the route registration AND the
 * list-page component. TanStack file-based routing auto-nests the
 * child route `catalog.functions.new` under this parent, but without
 * an <Outlet/> in the parent component, the child route had nowhere
 * to render and the list stayed mounted at
 * `/sysadmin/catalog/functions/new`.
 *
 * The list content moved to `catalog.functions.index.tsx` (route ID
 * `/sysadmin/catalog/functions/`). This file is now a pure layout,
 * mirroring the canonical sibling pattern at `routes/sysadmin/models.tsx`.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/catalog/functions')({
  component: FunctionsCatalogLayout,
});

function FunctionsCatalogLayout() {
  return <Outlet />;
}
